class KeycloakBS {
    keycloak = new Keycloak(keycloakConfig); // eslint-disable-line no-undef
    keycloakBaseLogin = this.keycloak.login;
    keycloakBaseLogout = this.keycloak.logout;

    _idpHint = null;
    get IdpHint() {
        return this._idpHint;
    }
    set IdpHint(value) {
        this._idpHint = value;
        this.updateKeycloakLoginLogout();
    }

    _redirectUri = null;
    get RedirectUri() {
        return this._redirectUri;
    }
    set RedirectUri(value) {
        this._redirectUri = this.getEncodedUrl(value);
        this.updateKeycloakLoginLogout();
    }

    constructor() {
        this.updateKeycloakLoginLogout();
    }

    hasToken() {
        return this.keycloak.token !== undefined && this.keycloak.token !== null;
    }

    getToken() {
        return this.keycloak.token;
    }

    didInitialize() {
        return this.keycloak.didInitialize === true;
    }

    getEncodedUrl(uri) {
        const url = new URL(decodeURI(uri.replace(/\+/g, '%20')));
        return url.href;
    }

    updateKeycloakLoginLogout() {
        this.keycloak.login = (options) => {
            const opts = options || {};
            opts.redirectUri = this.RedirectUri ? this.RedirectUri : this.getEncodedUrl(document.documentURI);
            if (this.IdpHint) {
                opts.idpHint = this.IdpHint;
            }
            this.keycloakBaseLogin(opts);
        };

        this.keycloak.logout = (options) => {
            const opts = options || {};
            opts.redirectUri = this.RedirectUri ? this.RedirectUri : this.getEncodedUrl(document.documentURI);
            this.keycloakBaseLogout(opts);
        };
    }

    enableSso() {
        console.log('Enable SSO');
        this.IdpHint = 'azurebs';
    }


    disableSso() {
        this.IdpHint = null;
        this.deleteUrlParam('sso');
    }

    deleteUrlParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete(param);
        window.history.replaceState(
            null,
            '',
            `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`
        );
    }

    login() {
        this.keycloak.login();
    }

    logout() {
        this.keycloak.logout();
    }
}

export default KeycloakBS;

